export enum OnboardingFormNavigationAction {
  Breadcrumb = 'Breadcrumb',
  ActionBar = 'ActionBar',
  NewOfferer = 'NewOfferer',
  UpdateFromValidation = 'UpdateFromValidation',
  JoinModal = 'JoinModal',
  WaitingLinkButton = 'WaitingLinkButton',
  LinkModalActionButton = 'LinkModalActionButton',
}
